import { ShieldCheck, Clock } from "lucide-react";
import { PageHero } from "../components/common/SectionHeading";
import { ContactForm } from "../components/forms/ContactForm";
import { usePageTitle } from "../lib/usePageTitle";

const NOTES = [
  { icon: Clock, text: "We usually respond within a few working days." },
  { icon: ShieldCheck, text: "Your details are used only to reply to your message." },
];

export default function ContactPage() {
  usePageTitle("Contact");
  return (
    <>
      <PageHero label="Contact" title="Let's talk." body="Questions about CARLINK, multiple vehicles or partnerships? Send us a message." />
      <section className="section-pad !pt-16">
        <div className="container-x grid gap-12 lg:grid-cols-[1fr_2fr]">
          <ul className="space-y-5">
            {NOTES.map(({ icon: I, text }) => (
              <li key={text} className="flex items-start gap-3 text-sm text-slate-400">
                <I className="mt-0.5 h-4 w-4 shrink-0 text-[#FF5500]" aria-hidden="true" />{text}
              </li>
            ))}
          </ul>
          <ContactForm />
        </div>
      </section>
    </>
  );
}
